// @flow
import * as React from 'react';

import Button from '../button';
import VisualDemo from './visual-demo';
import settings from '../settings';
import { getLocale } from '../i18n';

import t from './locale';
import cs from './styles.pcss';
import EbayLogo from './ebay-logo.svg';

export default function MainLandBlock(): React.Node {
  const locale = getLocale();

  return (
    <div className={cs.heroSection}>
      <div className={cs.heroGlow} aria-hidden="true" />
      <div className={cs.heroContent}>
        <div className={cs.topContent}>
          <h1 className={cs.mainTitle}>{t('title')}</h1>
          {locale === 'zh' && <h1 className={cs.mainTitle}>{t('subTitle')}</h1>}
          <p className={cs.description}>{t('description')}</p>
          <div className={cs.authButtonContainer}>
            <Button
              href={settings.signIn}
              area="mainLandingBlock"
              mode="filled"
              color="white"
              className={cs.heroButton}
              withArrow
            >
              {t('buttonTitle')}
            </Button>
          </div>
        </div>
        <VisualDemo />
      </div>
      <div className={cs.ebayLogoContainer}>
        {locale === 'de' ? (
          <>
            <span className={cs.logoText}>{t('logoText.part1')}</span>
            <span className={cs.logoText}>{t('logoText.part2')}</span>
            <EbayLogo className={cs.ebayLogo} />
          </>
        ) : (
          <>
            <span className={cs.logoText}>{t('logoText.part1')}</span>
            <EbayLogo className={cs.ebayLogo} />
            <span className={cs.logoText}>{t('logoText.part2')}</span>
          </>
        )}
      </div>
    </div>
  );
}
